import { render } from "./portfooter.vue?vue&type=template&id=5d950516"
import script from "./portfooter.vue?vue&type=script&lang=js"
export * from "./portfooter.vue?vue&type=script&lang=js"

import "./portfooter.vue?vue&type=style&index=0&id=5d950516&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__